export class Controller {

    /** @ngInject */
    constructor(RoleManagementResource) {
        this.RoleManagementResource = RoleManagementResource;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.RoleManagementResource
            .remove(this.resolve.companyId, this.resolve.appId, this.resolve.roleId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/remove/remove-role.controller.js